import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import roleService from "../service-api/roleMaster";
// import roleService from "../service-api/roleService";

// Initial state
const initialState = {
  data: [],
  activeRoles: [],
  error: null,
  isLoading: true,
};

export const fetchAllRoles = createAsyncThunk(
  "data/fetchAllRoles",
  async () => {
    const response = await roleService.fetchAllRoles();
    return response.data;
  }
);

export const fetchAllActiveRoles = createAsyncThunk(
  "data/fetchAllActiveRoles",
  async () => {
    const response = await roleService.fetchAllActiveRoles();
    return response.data;
  }
);

export const updateRole = createAsyncThunk(
  "data/updateRole",
  async ({ id, obj }, { dispatch }) => {
    const response = await roleService.updateRole(id, obj);
    dispatch(fetchAllRoles());
    return response.data;
  }
);

export const addRole = createAsyncThunk(
  "data/addRole",
  async ({ obj }, { dispatch }) => {
    const response = await roleService.addRole(obj);
    dispatch(fetchAllRoles());
    return response.data;
  }
);

// Create slice
const roleSlice = createSlice({
  name: "role",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllRoles.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchAllRoles.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.value;
      })
      .addCase(fetchAllRoles.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(fetchAllActiveRoles.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchAllActiveRoles.fulfilled, (state, action) => {
        state.isLoading = false;
        state.activeRoles = action.payload.value;
      })
      .addCase(fetchAllActiveRoles.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(updateRole.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateRole.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(updateRole.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(addRole.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addRole.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(addRole.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export default roleSlice.reducer;
